import { orderService } from '../../services/OrderService'

export default {
    name: 'CancelOrder',

    components: {
    },

    props:
    {
        itemToBeChanged: {},
    },


    data: () => {
        return {
            loading: true,
            addToBlackList: false,
            blackListText: ''
        }
    },

    computed: {
    },

    methods: {
        created() {

        },
        //
        backButtonClick: function () {

        },



    },
}
